import React from 'react';
import { Box, Typography, CardContent, Collapse } from '@mui/material';
import { CloudUpload as UploadIcon } from '@mui/icons-material';
import { BRAND_COLORS, SEMANTIC_COLORS } from '../../styles/theme';
import { UploadZone } from './styles';
import FileUploader from '../FileUploader';
import type { UploadOutcome } from '../file-uploader/uploadResults';
import AnalysisResult from './AnalysisResult';
import { useTranslation } from '../../i18n';

interface FileUploadZoneProps {
  show: boolean;
  currentPath: string;
  onUpload: (
    files: File[],
    metadata: {
      destinationPath: string;
      flightType: string;
      payloadId: number;
      pilotId: string;
      customerId: string;
      projectId: string;
      airspaceObserverId: string;
      payloadOperatorId: string;
    }
  ) => Promise<UploadOutcome | void>;
  onAnalyze: (file: File, flightType?: string) => Promise<void>;
  uploadLoading: boolean;
  analysisResult?: {
    success: boolean;
    metadata: Record<string, unknown>;
    rows_processed: number;
    columns_processed: number;
  };
  onCloseAnalysis?: () => void;
}

const FileUploadZone: React.FC<FileUploadZoneProps> = ({
  show,
  currentPath,
  onUpload,
  onAnalyze,
  uploadLoading,
  analysisResult,
  onCloseAnalysis,
}) => {
  const { t } = useTranslation();

  return (
    <Collapse in={show}>
      <UploadZone>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <UploadIcon sx={{ mr: 1, color: BRAND_COLORS.yellow.main }} />
            <Typography variant="h6" sx={{ color: BRAND_COLORS.forestGreen.main }}>
              {t('fileManagement.uploadFiles')}
            </Typography>
            <Box sx={{ ml: 'auto' }}>
              <Typography variant="body2" sx={{ color: SEMANTIC_COLORS.text.secondary }}>
                {t('fileManagement.uploadingTo', {
                  path: `/${currentPath || t('fileManagement.root').toLowerCase()}`,
                })}
              </Typography>
            </Box>
          </Box>
          <FileUploader
            onUpload={onUpload}
            onAnalyze={onAnalyze}
            loading={uploadLoading}
            currentPath={currentPath}
          />
          <AnalysisResult analysisResult={analysisResult} onClose={onCloseAnalysis} />
        </CardContent>
      </UploadZone>
    </Collapse>
  );
};

export default FileUploadZone;
